import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { adapter } from './animal-group.reducer';
import { AnimalGroupModuleState, ProductionType } from '../models/animal-group.model';

const { selectAll } = adapter.getSelectors();

export const getAnimalGroupModuleState =
  createFeatureSelector<AnimalGroupModuleState>('animalGroupModule');

export const getAnimalGroupsState = createSelector(
  getAnimalGroupModuleState,
  (state) => state.animalGroups,
);

export const getSelectedAnimalGroupId = createSelector(
  getAnimalGroupModuleState,
  RouterSelectors.getRouteParam('animalGroupId'),
  (state, animalGroupId) => {
    const routeAnimalGroupId = parseInt(animalGroupId, 10);
    if (!isNaN(routeAnimalGroupId) && routeAnimalGroupId > 0) {
      return routeAnimalGroupId;
    } else {
      return state.selectedAnimalGroupId;
    }
  },
);

export const getAnimalGroups = createSelector(getAnimalGroupsState, selectAll);

export const getSelectedAnimalGroup = createSelector(
  getSelectedAnimalGroupId,
  getAnimalGroups,
  (animalGroupId, animalGroups) => animalGroups.find(({ id }) => id === animalGroupId),
);

export const getSelectedFeedadviceApplicationId = createSelector(
  getAnimalGroupModuleState,
  (state) => state.selectedFeedadviceApplicationId,
);

export const getHasObservations = createSelector(
  getSelectedAnimalGroup,
  (animalGroup) =>
    !!animalGroup &&
    (animalGroup.productionType === ProductionType.FatteningPigs ||
      animalGroup.productionType === ProductionType.WeanedPiglets),
);

export const getSelectedFeedadviceApplication = createSelector(
  getSelectedAnimalGroup,
  getSelectedFeedadviceApplicationId,
  (animalGroup, feedadviceApplicationId) =>
    animalGroup.feedAdviceApplications.find((o) => o.id === feedadviceApplicationId),
);
